import { xCheck } from './xCheck';
import { xGetFromToIndex } from './xGetFromToIndex';
export function xAbsoluteSum(array, options = {}) {
    xCheck(array);
    const { fromIndex, toIndex } = xGetFromToIndex(array, options);
    let sum = 0;
    for (let i = fromIndex; i <= toIndex; i++) {
        if (array[i] < 0) {
            sum -= array[i];
        }
        else {
            sum += array[i];
        }
    }
    return sum;
}
//# sourceMappingURL=xAbsoluteSum.js.map